/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useMemo } from "react";
import {
  DocumentPageWrapper,
  ToolbarRow,
  ContentArea,
  TablePanel,
  PdfViewerContainer,
} from "./styled";
import { Button, Input, message, Table, Tooltip } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  UploadOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { sendDelete, sendGet } from "../../api/axios";
import ListHospital from "../../components/document/listHospital/ListHospital";
import Createfrom from "../../components/document/CreateForm/CreateFrom";
import FormInputData from "../FormInputData/FormInputData";
import ModalNormal from "../../components/common/modal";
import {
  CancelButton,
  CeckName,
  ConfirmWrapper,
  DeleteButton,
  InputDelete,
  SelectName,
} from "../FormInputData/styled";
import { useSelector } from "react-redux";
import { linkApi } from "../../common/ngok";

const { Search } = Input;

const Document = ({ title }) => {
  const { t } = useTranslation();

  const tabDocument = useSelector((state) => state.document.tab);

  const [ListDoc, setListDoc] = useState([]);
  const [selected, setSelected] = useState("");
  const [editing, setEditing] = useState(false);
  const [creating, setCreating] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [isShow, setIsShow] = useState(false);
  const [deleteCheck, setDeleteCheck] = useState("");

  const filteredDocs = useMemo(() => {
    if (!searchText) return ListDoc;
    const lower = searchText.toLowerCase();
    return ListDoc.filter(
      (doc) =>
        doc?.name?.toLowerCase().includes(lower) ||
        doc?.note?.toLowerCase().includes(lower)
    );
  }, [ListDoc, searchText]);

  const downLoadPdf = () => {
    if (!selected) {
      return;
    }
    window.open(`${linkApi}/media/${selected?.url}`);
  };

  const getDataDocument = async (callback, isFirst) => {
    try {
      const response = await sendGet("/dm/data/docs");
      setListDoc(response?.docs);
      if (callback) {
        callback(response?.docs[isFirst ? 0 : response?.docs?.length - 1]);
      }
    } catch (error) {
      message.error(t("document.fetchError"));
    }
  };

  const cancelModal = () => {
    setIsShow(false);
    setDeleteCheck("");
  };

  const handleDelete = async () => {
    try {
      const response = await sendDelete(`/dm/data/docs?id=${selected?.id}`);
      if (response) {
        getDataDocument((res) => {
          message.success(t("document.deleteSuccess"));
          setEditing(false);
          setCreating(false);
          setSelected("");
        });
      }
    } catch (error) {
      message.error(t("document.deleteError"));
      setEditing(false);
      setSelected("");
    } finally {
      setIsShow(false);
    }
  };

  useEffect(() => {
    getDataDocument(null, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "#",
      key: "index",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: t("document.documentName"),
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: t("document.documentNote"),
      dataIndex: "note",
      key: "note",
      ellipsis: true,
    },
    {
      title: "",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <span style={{ display: "flex", gap: 8 }}>
          <Tooltip title={t("document.download")}>
            <DownloadOutlined
              style={{ fontSize: 16, cursor: "pointer", color: "#0089cf" }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(`${linkApi}/media/${record?.url}`);
              }}
            />
          </Tooltip>
          <Tooltip title={t("document.updateDocument")}>
            <EditOutlined
              style={{ fontSize: 16, cursor: "pointer", color: "#52c41a" }}
              onClick={(e) => {
                e.stopPropagation();
                setSelected(record);
                setEditing(true);
                setCreating(false);
              }}
            />
          </Tooltip>
          <Tooltip title={t("document.deleteDocument")}>
            <DeleteOutlined
              style={{ fontSize: 16, cursor: "pointer", color: "#ff4d4f" }}
              onClick={(e) => {
                e.stopPropagation();
                setSelected(record);
                setIsShow(true);
              }}
            />
          </Tooltip>
        </span>
      ),
    },
  ];

  return (
    <DocumentPageWrapper>
      {tabDocument === 1 ? (
        <>
          <ToolbarRow>
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={() => {
                  setSelected(null);
                  setCreating(true);
                  setEditing(false);
                }}
              >
                {t("document.uploadDocument")}
              </Button>
              <Search
                placeholder={t("document.searchDocument")}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: 300 }}
                allowClear
              />
            </div>
            {selected && !creating && !editing && (
              <Button
                type="default"
                icon={<DownloadOutlined />}
                onClick={downLoadPdf}
              >
                {t("document.download")}
              </Button>
            )}
          </ToolbarRow>

          <ContentArea>
            {creating || editing ? (
              <div style={{ overflow: "auto", flex: 1, padding: 16 }}>
                {creating && (
                  <Createfrom
                    selected={selected}
                    getDataDocument={(cb) => {
                      getDataDocument((res) => {
                        if (cb) cb(res);
                        setCreating(false);
                      });
                    }}
                    setSelected={setSelected}
                  />
                )}
                {editing && (
                  <FormInputData
                    selected={selected}
                    setSelected={setSelected}
                    setEditing={setEditing}
                    getDataDocument={getDataDocument}
                  />
                )}
              </div>
            ) : (
              <>
                <TablePanel>
                  <Table
                    dataSource={filteredDocs}
                    columns={columns}
                    rowKey="id"
                    size="small"
                    pagination={{
                      pageSize: 5,
                      showSizeChanger: false,
                      size: "small",
                    }}
                    onRow={(record) => ({
                      onClick: () => {
                        setSelected(record);
                        setEditing(false);
                        setCreating(false);
                      },
                      style: {
                        cursor: "pointer",
                        background:
                          record?.id === selected?.id ? "#e6f7ff" : "inherit",
                      },
                    })}
                  />
                </TablePanel>
                <PdfViewerContainer>
                  {selected ? (
                    <iframe
                      title="Document Preview"
                      src={`${linkApi}/media/${selected?.url}`}
                      width="100%"
                      height="100%"
                    />
                  ) : (
                    <div style={{ color: "#888", textAlign: "center", paddingTop: 60 }}>
                      {t("document.searchOrUpload")}
                    </div>
                  )}
                </PdfViewerContainer>
              </>
            )}
          </ContentArea>
        </>
      ) : (
        <ListHospital />
      )}
      <ModalNormal
        visible={isShow}
        setVisible={setIsShow}
        onCancel={cancelModal}
        title={t("document.deleteDocument")}
      >
        <CeckName>
          {t("document.enterName")} <SelectName>{selected?.name}</SelectName>{" "}
          {t("document.toConfirm")}
        </CeckName>
        <InputDelete
          value={deleteCheck}
          onChange={(e) => setDeleteCheck(e?.target?.value)}
        />
        <ConfirmWrapper>
          <DeleteButton
            disabled={deleteCheck !== selected?.name}
            onClick={handleDelete}
          >
            {t("document.confirm")}
          </DeleteButton>
          <CancelButton onClick={cancelModal}>
            {t("document.cancel")}
          </CancelButton>
        </ConfirmWrapper>
      </ModalNormal>
    </DocumentPageWrapper>
  );
};

export default Document;
